// extracted by mini-css-extract-plugin
export var animationContainer = "_gc-0";
export var asteriskIcon = "_gc-8";
export var conversationLeftSection = "_gc-4";
export var conversationListItem = "_gc-3";
export var conversationMiddleSection = "_gc-5";
export var conversationRightSection = "_gc-6";
export var detailsContent = "_gc-1";
export var listContainer = "_gc-7";
export var modalContent = "_gc-2";